import { computed, ref } from 'vue';
import { TransitionPresets, useTransition } from '@vueuse/core';
import { useRouteHash } from '@libs/use';

import { ORDER_FILTERS, STATUS, ORDERS_LABEL } from '../constants';
import { getFilteredOrders } from '../utils/filterOrders';

export default function useFilterOrders(defaultOrders, orderFilter) {
  const routeHash = useRouteHash();

  const filter = ref(
    routeHash.value || orderFilter || ORDER_FILTERS.open.value
  );

  const orders = computed(() =>
    getFilteredOrders(defaultOrders.value, filter.value)
  );

  const filteredOrdersPercentage = computed(() => {
    return (orders.value.length / defaultOrders.value.length) * 100 || 0;
  });

  const percentage = useTransition(filteredOrdersPercentage, {
    duration: 300,
    transition: TransitionPresets.easeInOutCubic,
  });

  const filterLongLabel = computed(() => {
    if (filter.value === ORDER_FILTERS.all.value) {
      return ORDERS_LABEL;
    } else {
      return `${ORDERS_LABEL} ${STATUS[filter.value]}`;
    }
  });

  return {
    percentage,
    orders,
    filter,
    filterLongLabel,
  };
}
